import React from 'react'
import styled from 'styled-components'
import { H4, UserLocationMapping } from '@base'
import { ItemWrapper, Wrapper } from '@pages/Dashboard/styles'
import { Spacings } from '@styles'

const MapWrapper = styled(ItemWrapper)`
	min-height: 43rem;
`
const ItemHeader = styled(H4)`
	margin: 0 ${Spacings.SPACING_2B} ${Spacings.SPACING_4B} ${Spacings.SPACING_2B};
	color: ${({ theme }) => theme.palette.text.black};
	padding-bottom: ${Spacings.SPACING_3B};
	border-bottom: 1px solid ${({ theme }) => theme.palette.background.searchgrey};
`

const Maps = () => {
	return (
		<Wrapper>
			<MapWrapper fullWidth>
				<UserLocationMapping />
			</MapWrapper>
		</Wrapper>
	)
}

export default Maps